import { z } from "zod";

import { OptionI18nInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { SubOptionsZodSchema } from "../../../../_shared/model/validation-schema";

export const optionI18nInputZodSchema = OptionI18nInputSchema.extend({
	name: z.string().min(1).max(150),
	description: z.string().min(1).max(5_000),

	subOptions: SubOptionsZodSchema,
});

export type OptionI18nInputZodSchemaType = z.infer<typeof optionI18nInputZodSchema>;
